import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, SectionGroup } from 'Components/Layout';
import { WorksheetBalanceFieldSet } from 'Components/Worksheets/Core';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { IEmbeddedTestProps } from '../../types';
import BsEnDryMassesMultiTraysGridSection from './DryMassesMultiTraysGridSection';
import BsEnDryMassesSingleTraySection from './DryMassesSingleTraySection';

let BsEnDryMassesSection: React.FC<IEmbeddedTestProps> = ({ createWorksheetSelector, isEmbeddedTest }) => {
  const singleTray = useSelector(pipe(createWorksheetSelector!('DryingTrays'), (p) => p === undefined || p.length < 2));

  return (
    <SectionGroup>
      <ListFieldSection>
        <WorksheetBalanceFieldSet name="Equipment.DryMassBalance" />
      </ListFieldSection>
      {singleTray ? (
        <BsEnDryMassesSingleTraySection isEmbeddedTest={isEmbeddedTest} />
      ) : (
        <BsEnDryMassesMultiTraysGridSection isEmbeddedTest={isEmbeddedTest} />
      )}
    </SectionGroup>
  );
};

BsEnDryMassesSection = withInjectedProps(BsEnDryMassesSection);

export { BsEnDryMassesSection };
export default BsEnDryMassesSection;
